/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Antifreezealarmsetpoint3Inputs */



/**
* | output |
* | --- |
* | "Antifreeze alarm setpoint" |
*
* @param {Ahu_History_Key_Antifreezealarmsetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_antifreezealarmsetpoint3 = /** @type {((inputs?: Ahu_History_Key_Antifreezealarmsetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Antifreezealarmsetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Antifreeze alarm setpoint")
	return /** @type {LocalizedString} */ ("Consigne alarme antigel")
});
export { ahu_history_key_antifreezealarmsetpoint3 as "ahu_history_key_antiFreezeAlarmSetpoint" }